import _extends from "@babel/runtime/helpers/extends";
import React, { useCallback, useMemo } from 'react';
import { components } from 'react-select';
import Text from '../../../typography/Text';
import Checkbox from '../../../general/Checkbox';
import classnames from 'classnames';
export default /*#__PURE__*/React.memo(_ref => {
  let {
    children,
    ...props
  } = _ref;
  const {
    className,
    selectAllClassName,
    selectAllSelectedClassName,
    selectAllCheckboxClassName,
    selectAllTextClassName,
    override,
    dropdownWidth,
    selectAllLabel,
    selectRef,
    value,
    setIsSelectAllFocused
  } = props.selectProps.menuListProps;
  const {
    options,
    filterOption,
    inputValue
  } = props.selectProps;
  const filteredOptions = useMemo(() => {
    if (!(options !== null && options !== void 0 && options.length)) return [];
    if (filterOption) {
      return options.filter(current => !current.isDisabled && filterOption(current, inputValue));
    }
    return options.filter(current => !current.isDisabled);
  }, [options, filterOption, inputValue]);
  const mappedFilteredOptions = useMemo(() => {
    if (!(filteredOptions !== null && filteredOptions !== void 0 && filteredOptions.length)) return {};
    return filteredOptions.reduce((obj, current) => {
      obj[current.value] = current;
      return obj;
    }, {});
  }, [filteredOptions]);
  const isIndeterminate = useMemo(() => {
    if (!(value !== null && value !== void 0 && value.length)) return false;
    const selected = value.filter(current => mappedFilteredOptions[current.value]);
    if (selected !== null && selected !== void 0 && selected.length && (filteredOptions === null || filteredOptions === void 0 ? void 0 : filteredOptions.length) !== (selected === null || selected === void 0 ? void 0 : selected.length)) return true;
    return false;
  }, [value, mappedFilteredOptions, filteredOptions]);
  const isAllSelected = useMemo(() => {
    if (!(value !== null && value !== void 0 && value.length)) return false;
    const selected = value.filter(current => mappedFilteredOptions[current.value]);
    return selected.length === filteredOptions.length;
  }, [filteredOptions, value, mappedFilteredOptions]);
  const onClickAll = useCallback(() => {
    if (isAllSelected || isIndeterminate) {
      if (inputValue && filteredOptions.length) {
        let newOptions = (value === null || value === void 0 ? void 0 : value.filter(current => !mappedFilteredOptions[current.value])) || [];
        selectRef.setValue(newOptions, 'set-value');
      } else {
        selectRef.clearValue();
      }
    } else {
      if (inputValue && filteredOptions.length) {
        selectRef.setValue([...(value || []), ...filteredOptions], 'set-value');
      } else {
        selectRef.setValue(filteredOptions, 'set-value');
      }
    }
  }, [isAllSelected, filteredOptions, selectRef, isIndeterminate, inputValue, value, mappedFilteredOptions]);
  const handleOnEnter = useCallback(() => {
    if (!selectAllLabel) return;
    setIsSelectAllFocused(true);
  }, [selectAllLabel, setIsSelectAllFocused]);
  const handleOnLeave = useCallback(() => {
    if (!selectAllLabel) return;
    setIsSelectAllFocused(false);
  }, [selectAllLabel, setIsSelectAllFocused]);

  // It depents also on filterOption, because without it won't have a correct behavior
  var _ref2 = /*#__PURE__*/React.createElement(Text, {
    className: selectAllTextClassName
  }, selectAllLabel);
  const allRow = useMemo(() => {
    if (!selectAllLabel || !(filteredOptions !== null && filteredOptions !== void 0 && filteredOptions.length) || !filterOption) return null;
    return /*#__PURE__*/React.createElement("div", {
      className: classnames(selectAllClassName, {
        [selectAllSelectedClassName]: isAllSelected || isIndeterminate
      }),
      onClick: onClickAll,
      onMouseEnter: handleOnEnter,
      onMouseLeave: handleOnLeave
    }, /*#__PURE__*/React.createElement(Checkbox, {
      className: selectAllCheckboxClassName,
      checked: isAllSelected || isIndeterminate,
      color: "orange",
      indeterminate: isIndeterminate
    }), _ref2);
  }, [selectAllClassName, selectAllSelectedClassName, selectAllCheckboxClassName, selectAllTextClassName, selectAllLabel, onClickAll, isAllSelected, isIndeterminate, filteredOptions, handleOnEnter, handleOnLeave, filterOption]);
  const innerProps = useMemo(() => {
    if (dropdownWidth) return {
      ...props.innerProps,
      style: {
        width: dropdownWidth
      }
    };
    return props.innerProps;
  }, [dropdownWidth, props]);
  return components.MenuList && /*#__PURE__*/React.createElement(components.MenuList, _extends({}, props, {
    className: className,
    innerProps: innerProps
  }, override.menuList), allRow, children);
});